import Component from '@glimmer/component'
import { service } from '@ember/service'
import { t } from 'ember-intl'
import PageHeaderReturnLink from 'teacher-ui-client/components/page-header/return-link'
import type SchoolRolloverService from 'teacher-ui-client/services/school-rollover'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'

export class RolloverHeaderReturnLink extends Component<unknown> {
  @service schoolRollover!: SchoolRolloverService

  @service subscriptionType!: SubscriptionTypeService

  get continueRolloverRouteName() {
    return this.subscriptionType.current && this.schoolRollover.continueRolloverRouteName(this.subscriptionType.current)
  }

  <template>
    {{#if this.continueRolloverRouteName}}
      <PageHeaderReturnLink @route={{this.continueRolloverRouteName}}>
        {{t "manage.rollover.returnLink"}}
      </PageHeaderReturnLink>
    {{/if}}
  </template>
}

export default RolloverHeaderReturnLink
